import { FileUploadStatus } from '../Cloud/type';
import { CSFInsightPermissionLevel } from '../FileCard/types';
import documentFolderIcon from '../../../../../assets/images/document-folder.svg';
import myDriveIcon from '../../../../../assets/images/my_drive_icon.svg';
import fromTtcxIcon from '../../../../../assets/images/from_ttcx_icon.svg';
import fromTtamIcon from '../../../../../assets/images/from_ttam_icon.svg';
import fromProgramme from '../../../../../assets/images/from_programme_icon.svg';

export enum FileType {
  Folder = 1,
  Image = 2,
  Video = 3,
  // Pdf,
  Other = 4,
  Item = 5,
  Zip = 6,
  Json = 7 // 目前专指 VSA lottie 文件格式
}

export enum NodeTypeEnum {
  Folder = 'folder',
  Category = 'category',
  Campaign = 'campaign',
  File = 'file'
}

export interface NodeConfig {
  id?: string;
  name?: string;
  parentId?: string;
  fileCount?: number;
  description?: string;
  createTime?: Date;
  updateTime?: Date;
  isProtected?: boolean;
  folderId?: string;
  folderList?: Array<NodeConfig>;
  logo?: string;
}

export enum ProtectTypeEnum {
  Unprotected = 0, // offline
  Protected = 1, // system program
  Freezed = 2 // partner 被移除当前 system program
}

export interface FolderSources {
  orderFolders?: FolderData[];
  uploadFolders?: FolderData[];
  ttamFolders?: FolderData[];
  programFolders?: FolderData[];
  sharedFolders?: FolderData[]; //todo remove
  seriesFolders?: FolderData[];
}

export interface FolderData {
  folderId: string;
  fileType: FileType;
  name: string;
  description: string;
  createTime: number;
  folderList: FolderData[];
  parentId: string;
  isDefaultFolder?: boolean; // 是否为默认创建的文件夹（无法删除和编辑）
  isProtected?: boolean; // system (true) | offline (false) (including ttcx partner and agency)
  isSyncFolder?: boolean; // 是否为 agency 通过 adv 同步的 folder
  isStopSync?: boolean; // agency 同步 adv 权限停止
  protectedType?: ProtectTypeEnum;
  isAllowRename?: boolean;
}

export interface FileData {
  folderId: string;
  fileId: string;
  fileType: FileType;
  name: string;
  fileKey: string;
  fileUrl: string;
  extraData: { [key: string]: any };
  coverUrl: string;
  createTime: number;
  updateTime: number;
  protectedType?: ProtectTypeEnum;
  isAllowRename?: boolean;
  duration?: number;
  permissionLevel?: CSFInsightPermissionLevel;
  materialId?: string;
  isValid?: boolean;
  watermarkReady?: boolean;
  authAdvNum?: number;
  totalAdvNum?: number;
}

export enum FileStatus {
  waiting,
  error,
  success,
  loading
}

export enum UploadTaskType {
  file,
  folder,
  cloudFile
}

export interface UploadTask {
  uuid: string;
  data: UploadFile | UploadFolder | FileUploadStatus;
  taskType: UploadTaskType;
}

export interface UploadFolder {
  name: string;
  uuid: string;
  data: UploadFile[];
  progress: number;
  status: FileStatus;
  folderId?: string;
}

export interface UploadFile {
  fileType: FileType;
  name: string;
  progress: number;
  uuid: string;
  file: File;
  status: FileStatus;
  folderId?: string;
  fileHash?: string;
  filePath?: string;
  errorMsg?: string;
}

export interface DownloadFile extends FileData {
  status: FileStatus;
  progress: number;
  uuid: string;
  cancel?: () => void;
}

export interface AssetTranslate {
  upload?: string;
  uploadFolder?: string;
  sortBy?: string;
  downloads?: string;
  updateTime?: string;
  uploadTime?: string;
  views?: string;
  files?: string;
  confirm?: string;
  close?: string;
  uploading?: string;
  uploadCompleted?: string;
  uploadError?: string;
  folderDefaultName?: string;
  categoryDefaultName?: string;
  deleteConfirmTitle?: string;
  deleteConfirmContent?: string;
  videoDescription?: string;
  lastUpdatedTime?: string;
  challengeName?: string;
  viewsTimes?: string;
  downloadsTimes?: string;
  selectAllFiles?: string;
  item?: string;
  items?: string;
  haveBeenSelect?: string;
  success?: string;
  failed?: string;
  updating?: string;
  deleteSuccess?: string;
  deleteFailed?: string;
  moveSuccess?: string;
  moveFailed?: string;
  initFailed?: string;
  saveSuccess?: string;
  saveFailed?: string;
  updateSuccess?: string;
  updateFailed?: string;
  noSelectFolderBodyText?: string;
  dragFile?: string;
  clickUpload?: string;
  deleteConfirm?: string;
  deleteTitle?: string;
  createNewFolder?: string;
  moveTo?: string;
  rename?: string;
  delete?: string;
  move?: string;
  download?: string;
  preview?: string;
  renameTheFolder?: string;
  deleteTheFolder?: string;
  detail?: string;
  fileInformation?: string;
  emptyInfo?: string;
  inputExceedMaxLengthLimit?: string;
  createCountExceedMaxLimit?: string;
  downloading?: string;
  barTitle?: string;
  noDownloadTransfer?: string;
  noUploadTransfer?: string;
  downloadCompleted?: string;
  file?: string;
  folderFreezedHint?: string;
  videosBulkApplyPermission?: string;
  systemProgram?: string;
  offlineAssets?: string;
  authRecord?: string;
  allAssets?: string;
  authorized?: string;
  partialAuthorized?: string;
  noAssociatedAdv?: string;
  noAccess?: string;
  noData?: string;
  newFolder?: string;
  sendToAM?: string;
  share?: string;
  viewInsight?: string;
  open?: string;
  noAssets?: string;
  dropFilesOr?: string;
  folderLevelExceedsQuota?: string;
  allFiles?: string;
  linkCopied?: string;
  shareModalTitle?: string;
  linkGenerating?: string;
  copyLink?: string;
  linkExpirationHint?: string;
  linkAccess?: string;
  sharingPageTitle?: string;
  syncDisabledHint?: string;
  cancel?: string;
  folderSearchPlc?: string;

  // sync dav modal starling
  syncFromAdv?: string;
  noCreativeData?: string;
  addAssetsEntry?: string;
  syncAdvFolderEmptyTips?: string;
  syncAdvModalTitle?: string;
  synAdvNavUnSynced?: string;
  synAdvNavSynced?: string;
  synAdvNavStopSynced?: string;
  synAdvFooterConfirm?: string;
  synAdvFooterDesc?: string;
  syncAdvModalTableHeaderAdvName?: string;
  syncAdvModalTableHeaderAdvId?: string;
  syncAdvModalTableHeaderAdvStatus?: string;
  syncAdvModalTableHeaderAdvAssetsEnum?: string;
  syncAdvModalTableHeaderAdvSyncTime?: string;
  syncAdvModalTableHeaderAdvLastSyncTime?: string;
  syncAdvSuccessInfo?: string;
  syncAdvErrorInfo?: string;
}

export interface AssetApi {
  getFolderList: Function;
  createFolder: Function;
  createFile: Function;
  updateFolder: Function;
  updateFile: Function;
  moveFolder: Function;
  moveFile: Function;
  deleteFolder: Function;
  deleteFile: Function;
  getAssetsList: Function;
  generateAssetSharingLink?: any;
  getAdvertiserList?: Function;
  sendVideoToTtam?: Function;
  checkUploadedByMd5: (md5Str: string, folderId: string) => Promise<boolean>;

  // sync dav modal api
  getUnSyncedCSFAdvList?: Function;
  getCSFSyncedAdvList?: Function;
  syncCSFAdvertiser?: (params: any) => Promise<any>;
}

export interface AssetEvent {
  createFolder?: Function;
  renameFolder?: Function;
  deleteAssets?: Function;
  deleteFolder?: Function;
  renameFile?: Function;
  deleteFile?: Function;
  navShare?: Function;
  navSync?: Function;
  showMaxFolderDepthExceededModal?: Function;
  showDuplicateFolderNameModal?: Function;
  importFromCloudSpace?: Function;

  // sync dav for agency partner
  addAssetsButtonHover?: Function;
  addAssetsUploadClick?: Function;
  addAssetsSyncAdvClick?: Function;
  syncAdvModalExpose?: Function;
  syncAdvModalSync?: Function;
}

export interface CampaignDetail {
  campaignId?: string;
  brandType?: number;
  brandName: string;
  title: string;
  brandLogo: string;
  appIntroduction?: string;
  appKeySellingPoints?: string;
  appUseScenarios?: {
    userType?: string;
    userNeed?: string;
    productStrength?: string;
    solveProblem?: string;
  };
  appPronunciation?: string;
  niceToHaveKeywords?: string;
  sampleVideos?: {
    videoId?: string;
    videoName?: string;
    videoDescription?: string;
  };
  creatorRestrictions?: string[];
  appIosLink?: string;
  appAndroidLink?: string;
  appAdCreativeAssets?: string;
  asoKey?: string;
  email?: string;
  websiteLink?: string;
  syncAdvIds?: string[];
}

export interface CampaignDetailReq {
  challengeCampaign: CampaignDetail;
}

export interface Folder {
  folderId: string;
  name: string;
  createTime: string;
  fileCount: number;
  isProtected: boolean;
  folderList: Folder[];
}

export enum AdvSyncStatus {
  NotSync = 1,
  Sync = 2,
  StopSync = 3
}

export interface SyncAdvInfo {
  advId: string;
  advertiserName: string;
  syncStartTime: number;
  lastSyncTime: number;
  status: AdvSyncStatus;
}

export interface SyncAdvParams {
  parentFolderId: string;
  advertiserIds: string[];
}

export interface CreateUpdateFolderReq {
  campaignId: string;
  folderId?: string;
  name: string;
}

export interface DeleteFolderReq {
  campaignId: string;
  folderId?: string;
}

export interface GetFileReq {
  campaignId: string;
  folderId: string;
  orderType: number;
  page: number;
  limit: number;
}

export interface GetFolderReq {
  campaignId: string;
  folderId?: string;
  page: number;
  limit: number;
}

export interface CreateUpdateFileReq {
  campaignId: string;
  folderId: string;
  name: string;
  description: string;
  fileType: FileType;
  fileKey: string;
}

export interface Pagination {
  hasMore: boolean;
  totalCount: number;
  limit: number;
  page: number;
}

export enum OperateType {
  rightClick = 'rightClick',
  dropMenu = ' dropMenu',
  batch = 'batch',
  doubleClick = 'doubleClick',
  leftNav = 'leftNav',
  rightDetail = 'rightDetail'
}

export enum SyncSourceType {
  fromNavBar = 'navBar',
  fromImpNavBar = 'impNavBar',
  fromPreview = 'preview'
}

export interface CustomEventKey {
  sortFile?: string;
  deleteFileTimes?: string;
  downloadFileTimes?: string;
  detailFileTimes?: string;
  moveFileTimes?: string;
  previewFileTimes?: string;
  renameFileTimes?: string;
  uploadFileTimes?: string;
  createFolderTimes?: string;
  modifyDescriptionTimes?: string;
}

export enum AssetSource {
  MyDrive = 'uploadFolders',
  TTCX = 'orderFolders',
  TTAM = 'ttamFolders',
  Programme = 'programFolders',
  Series = 'seriesFolders',
  Shared = 'sharedFolders'
}

export const AssetSourceCode = {
  [AssetSource.TTCX]: 10008,
  [AssetSource.TTAM]: 10005,
  [AssetSource.Programme]: 10006,
  [AssetSource.Series]: 10007,
  [AssetSource.Shared]: 10002
};

export enum FolderType {
  sourceFolder = 1,
  rootFolder = 2
}

export const sourceInfoMap = {
  [AssetSource.TTCX]: {
    titleKey: 'asset_lib_source_ttcx',
    fallback: 'From TTCX orders',
    icon: fromTtcxIcon,
    descKey: 'asset_lib_ttcx_desc',
    descFallback: 'Assets synced from your TTCX orders arranged in folders of the order name'
  },
  [AssetSource.TTAM]: {
    titleKey: 'asset_lib_source_ttam',
    fallback: 'From TTAM',
    icon: fromTtamIcon,
    descKey: 'asset_lib_ttam_desc',
    descFallback: 'Assets synced from TTAM accounts that your account linked to'
  },
  [AssetSource.Programme]: {
    titleKey: 'asset_lib_source_programme',
    fallback: 'From programme',
    icon: fromProgramme,
    descKey: 'asset_lib_programme_desc',
    descFallback: 'Assets synced from the programme campaign that you joined'
  },
  [AssetSource.Shared]: {
    titleKey: 'asset_lib_source_share',
    fallback: 'My Drive',
    icon: myDriveIcon,
    descKey: 'asset_lib_my_drive_desc',
    descFallback: 'Manage assets that you and your team added'
  },
  [AssetSource.Series]: {
    titleKey: 'asset_lib_source_series',
    fallback: 'Series',
    icon: documentFolderIcon,
    descKey: 'asset_lib_series_desc',
    descFallback: 'Manage assets that from your series'
  }
};

export enum ReferrerType {
  TTCX = 1,
  SERIES = 2
}
